const id_whs_goodsdetail = {
    label: {
        location_start: "Lokasi Awal",
        location_final: "Lokasi Akhir",

        note_convertion: "Dihasilkan Dari Konversi",
        note_goods: "Dihasilkan Dari Barang",

        status_stock: "Status Stok",
    },
}

export default id_whs_goodsdetail;